
  import Vue from 'vue'
  import ReadingService from '@/services/ReadingService';
  import ImageService from '@/services/ImageService';
import { extractErrorMessage } from '@/utils/Util';

  export default Vue.extend({
    name: 'ReadingDeleteDialog',
    props: ['reading'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmDelete() {
        this.loading = true;
      
        ReadingService.deleteReading(this.$root.$store.state.session.selectedTenant.uuid, this.reading.uuid).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('reading.successDelete') as string;
            this.alertVisible = true;
            this.loading = false;

            return ImageService.deleteImage('readings', this.reading.uuid);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('reading.errorDelete') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        }).then(() => {
            this.loading = false;
            this.alertType = "success";
            this.alertText = this.$t('reading.successImageDelete') as string;
            this.alertVisible = true;
            setTimeout(() => { 
                this.$emit("delete", this.reading);
                this.dismiss(); 
            }, 2000);
        }).catch((err: any) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('reading.errorImageDelete') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
            setTimeout(() => { 
                this.$emit("delete", this.reading);
                this.dismiss(); 
            }, 2000);
        });
      }
    }
  })
